import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { oilCp } from './components/oilCp/oilCp.component';


const routes: Routes = [
  {
    path: '',
    children: [
      { path: '', redirectTo: 'oil-cp', pathMatch: 'full' },
      { path: 'oil-cp', component: oilCp },
    ]
  },
  {
    path: '**', redirectTo: ''
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
